/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// ../~/webpack/buildin/amd-options.js
// module id = 2197
// module chunks = 1